import { Injectable, inject } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { PermissionDefinitionModel, PermissionService } from '@shared/services/permission.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {
  private readonly permissionService = inject(PermissionService);

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const preload = route?.data?.preload;
    const permissionDefinitions = route?.data?.permissions as PermissionDefinitionModel[];
    return preload || this.permissionService.hasCurrentUserRequiredPermissions(permissionDefinitions) ? load() : of(null);
  }
}
